import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_internal_stock_requisition_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    location_code_from: fromDatatype.VarcharDatatypeInterface;
    location_from_guid: fromDatatype.GuidDataFieldInterface;
    location_from_validation_error: fromDatatype.VarcharDatatypeInterface;
    location_code_to: fromDatatype.VarcharDatatypeInterface;
    location_to_guid: fromDatatype.GuidDataFieldInterface;
    location_to_validation_error: fromDatatype.VarcharDatatypeInterface;
    hdr_ref_no: fromDatatype.VarcharDatatypeInterface;
    hdr_ref_no_validation_error: fromDatatype.VarcharDatatypeInterface;
    txn_date: fromDatatype.VarcharDatatypeInterface;
    txn_date_error: fromDatatype.VarcharDatatypeInterface;
    item_guid: fromDatatype.GuidDataFieldInterface;
    item_validation_error: fromDatatype.VarcharDatatypeInterface;
    hdr_description: fromDatatype.TextDatatypeInterface;
    hdr_remarks: fromDatatype.TextDatatypeInterface;
    item_code: fromDatatype.VarcharDatatypeInterface;
    item_name: fromDatatype.VarcharDatatypeInterface;
    item_ref_no: fromDatatype.VarcharDatatypeInterface;
    item_remarks: fromDatatype.TextDatatypeInterface;
    item_desc: fromDatatype.TextDatatypeInterface;
    qty: fromDatatype.NumericDatatypeInterface;
    qty_validation_error: fromDatatype.VarcharDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    generic_id_guid: fromDatatype.GuidDataFieldInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: boolean;
    processed: boolean;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_internal_stock_requisition_import_file_helper_RowClass implements bl_fi_internal_stock_requisition_import_file_helper_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
  location_code_from: fromDatatype.VarcharDatatypeInterface;
  location_from_guid: fromDatatype.GuidDataFieldInterface;
  location_from_validation_error: fromDatatype.VarcharDatatypeInterface;
  location_code_to: fromDatatype.VarcharDatatypeInterface;
  location_to_guid: fromDatatype.GuidDataFieldInterface;
  location_to_validation_error: fromDatatype.VarcharDatatypeInterface;
  hdr_ref_no: fromDatatype.VarcharDatatypeInterface;
  hdr_ref_no_validation_error: fromDatatype.VarcharDatatypeInterface;
  txn_date: fromDatatype.VarcharDatatypeInterface;
  txn_date_error: fromDatatype.VarcharDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_validation_error: fromDatatype.VarcharDatatypeInterface;
  hdr_description: fromDatatype.TextDatatypeInterface;
  hdr_remarks: fromDatatype.TextDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  item_ref_no: fromDatatype.VarcharDatatypeInterface;
  item_remarks: fromDatatype.TextDatatypeInterface;
  item_desc: fromDatatype.TextDatatypeInterface;
  qty: fromDatatype.NumericDatatypeInterface;
  qty_validation_error: fromDatatype.VarcharDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_id_guid: fromDatatype.GuidDataFieldInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  short_error_message: fromDatatype.TextDatatypeInterface;
  error_stack_trace: fromDatatype.TextDatatypeInterface;
  validated: boolean;
  processed: boolean;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
